import { makeStyles } from 'tss-react/mui';

const name = 'SubchainLabels';

export const useSubchainLabelsStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
  },
  label: {
    height: 20,

    padding: theme.spacing(1, 2),

    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,

    whiteSpace: 'nowrap',

    fontSize: 14,
  },
}));
